module.exports = __webpack_public_path__ + "static/media/refresh.8c19f649.svg";